import { useNavigate } from "react-router";
import axiosInstance, { api } from "../common/api";
import TablePage from "../components/TablePage";
import PageTitle from "../components/PageTitle";
import { Button, Flex } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";

export default function ({
  title,
  description,
  resource,
  columns,
  actionsMenu = {},
  readOnly = false,
  children,
  ...props
}) {
  const navigate = useNavigate();
  const fetch = (params) => api[resource].list(params);

  return (
    <Flex vertical gap={24}>
      <PageTitle
        title={title}
        description={description}
        extra={
          !readOnly && (
            <Button
              type="primary"
              size={"large"}
              icon={<PlusOutlined />}
              onClick={() => navigate("new")}
            >
              Aggiungi
            </Button>
          )
        }
      />
      <TablePage
        rowKey="id"
        enableSelection={!readOnly}
        onRowClick={readOnly ? undefined : (record) => navigate(`${record.id}`)}
        id={resource}
        actionsMenu={
          readOnly
            ? {}
            : {
                items: (record) => [
                  ...(actionsMenu.items?.(record) ?? []),
                  { key: "edit", label: "Modifica", icon: <EditOutlined /> },
                  { key: "delete", label: "Rimuovi", danger: true, icon: <DeleteOutlined /> },
                ],
                onClick: (key, record, refresh) => {
                  if (key === "edit") navigate(`${record.id}/edit`);
                  if (key === "delete") api[resource].delete(record.id).finally(refresh);
                  actionsMenu.onClick?.(key, record, refresh);
                },
              }
        }
        toolbarProps={(refresh) => ({
          addAction: () => navigate("new"),
          editAction: (key) => navigate(`${key}/edit`),
          deleteAction: (keys) => axiosInstance.delete(`${resource}/${keys[0]}`).finally(refresh),
        })}
        columns={columns}
        fetchFunction={fetch}
        {...props}
      >{children}</TablePage>
    </Flex>
  );
}
